import { render } from "./Invites.vue?vue&type=template&id=207f238c&scoped=true"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"

import "./Invites.vue?vue&type=style&index=0&id=207f238c&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207f238c"]])

export default __exports__